import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

/**
 * Segmented pill toggle. Use for sets of mutually-exclusive options where
 * a dropdown feels heavier than needed (window selectors, direction filters).
 *
 * Usage:
 *   <PillGroup>
 *     {options.map(o => (
 *       <PillButton key={o} active={current === o} onClick={() => set(o)}>
 *         {label(o)}
 *       </PillButton>
 *     ))}
 *   </PillGroup>
 */
export const PillGroup = styled.div`
  display: inline-flex;
  border: 1px solid ${({ theme }) => theme.border.color.medium};
  border-radius: ${({ theme }) => theme.border.radius.sm};
  overflow: hidden;
`;

interface PillButtonProps {
  active: boolean;
}

export const PillButton = styled('button', {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'active',
})<PillButtonProps>`
  padding: ${({ theme }) => theme.spacing(1, 2)};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  border: none;
  cursor: pointer;
  background: ${({ theme, active }) => active ? theme.accent.primary : theme.background.primary};
  color: ${({ theme, active }) => active ? '#fff' : theme.font.color.secondary};
  transition: ${({ theme }) => theme.animation.transition.standard};

  & + & {
    border-left: 1px solid ${({ theme }) => theme.border.color.medium};
  }

  &:hover:not([disabled]) {
    color: ${({ theme, active }) => active ? '#fff' : theme.accent.primary};
  }
`;
